<script lang="ts">
    import SnowtrexVisibleDates from '$saga/views/Tour/VisibleDates/SnowtrexVisibleDates/SnowtrexVisibleDates.svelte';
    import type {
        SnowtrexAccommodationDate,
        SnowtrexMonthlyPrices,
        SnowtrexSelection,
    } from '$saga/views/Tour/VisibleDates/types';

    export let snowtrexAccommodationDates: SnowtrexAccommodationDate[];
    export let cheapestMonthlyPrices: SnowtrexMonthlyPrices;
    export let onAccommodationSelected: (selection: SnowtrexSelection) => void;
</script>

<div class="py-l">
    <SnowtrexVisibleDates
        {snowtrexAccommodationDates}
        {cheapestMonthlyPrices}
        {onAccommodationSelected}
    />
</div>
